import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomTable from "../../components/Shared/CustomTable";
import PageHeader from "../../components/Shared/PageHeader";

const IncomeDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const accountsData = location.state?.accountsData || [];
  const title = location.state?.title || t("Details");
  const activeTabIndex = location.state?.activeTabIndex || 1; // Default back to Income Report tab

  const columns = [
    {
      header: t("Account Name"),
      body: (row) => row?.account_name + "-" + row?.account_code,
      field: "account_name",
    },
    {
      header: t("Account Type"),
      field: "account_type",
    },
    {
      header: t("Total Credit"),
      body: (row) => row?.total_credit + " " + t("SAR"),
      field: "total_credit",
    },
    {
      header: t("Total Debit"),
      body: (row) => row?.total_debit + " " + t("SAR"),
      field: "total_debit",
    },
    {
      header: t("Balance"),
      body: (row) => row?.balance + " " + t("SAR"),
      field: "balance",
    },
  ];

  return (
    <div className="flex rounded-md w-full gap-2 flex-col icon_hover">
      <PageHeader
        title={t(title)}
        onBack={() =>
          navigate("/manager/report", { state: { activeTabIndex } })
        }
      />
      <div className="h-full overflow-y-auto">
        <CustomTable data={accountsData} columns={columns} />
      </div>
    </div>
  );
};

export default IncomeDetailPage;
